<template>
  <section id="vic-results">
    <article>
      <div class="header row clearfix">
        <img src="@/assets/img/2018/map-vic.png">

        <h1>Victoria</h1>
      </div>
      <div class="row clearfix">
        <div style="width: 80%;margin: 0 auto 30px;">
          <figure>
            <h2>State Trends</h2>
            <div class="chart-wrapper">
              <highcharts class="graphcontainer" :options="trends"></highcharts>
              <div class="nb" style="text-align: center;">NB: 2018 figures have been updated to account for an error in the data received.</div>
            </div>
          </figure>
        </div>
      </div>
      <div class="row clearfix">
        <figure class="sixcol chart">
          <h2>Category Share</h2>
          <div class="chart-wrapper">
            <highcharts class="graphcontainer pie" :options="activeCatShare"></highcharts>
            <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
            <div class="nb">Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
          </div>
        </figure>
        <figure class="sixcol chart last">
          <h2>Regional/Metro Comparision</h2>
          <div class="chart-wrapper">
            <highcharts class="graphcontainer pie" :options="compRegionalMetro"></highcharts>
            <div class="nb">NB: Numbers may not total 100.0% due to a small proportion <br>of unidentified locations.</div>
          </div>
        </figure>
      </div>
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/VIC  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          VIC LPA Infographic Report 2025 (PDF)
        </a>
      </div>
    </article>
    <div class="fullbg">
      <p class="caption">Photo: <em>Steph Tisdell</em>, Melbourne International Comedy Festival, Photo Credit: Nick Robertson</p>
      <div class="overlay"></div>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
export default {
  data () {
    return {
      activeYear: 2025,
      trends: {
        chart: {
          type: 'column',
          backgroundColor: 'transparent'
        },
        title: {
          style: { color: '#fff' },
          text: 'Total Revenue and Attendance'
        },
        legend: {
          itemStyle: { color: '#fff', fontWeight: 'normal' },
          itemHoverStyle: { color: '#fff' }
        },
        xAxis: {
          categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
          labels: {
            style: {
              color: '#fff'
            },
            rotation: -45,
            staggerLines: 1,
          }
        },
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter () {
              if (this.value > 999) {
                // return this.key +'<br />'+this.y+'% '
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            format: '{value}m',
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter () {
            let revy, tooltipstring, avg;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y.toFixed(2) + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            for (let i=0; i<chart.series.length; i++) {
              let series = chart.series[i];
              avg = series.data[index].y;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(3) + 'b'
            }
            else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy
            return tooltipstring
          }
        },
        series: [
          {
            name: 'Revenue',
            data: [347.305, 451.053, 385.644, 344.389, 473.517, 450.034, 436.934, 440.33, 639.877, 600.318, 627.379, 158.294, 157.935, 684.355, 984.652, 1131.368, 1088.345],
            color: '#3a89eb',
          },
          {
            name: 'Attendance',
            data: [4.744, 5.821, 5.36, 4.917, 5.607, 5.319, 5.548, 5.431, 7.364, 7.52, 7.408, 1.547, 2.372, 7.857, 9.199, 9.879, 9.53],
            color: '#d14967',
            type: 'column',
            yAxis: 1,
          }
        ]
      },
      compRegionalMetro: {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent'
        },
        legend: {
          itemStyle: { color: '#fff', fontWeight: 'normal' },
          itemHoverStyle: { color: '#fff' }
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1
              }
            }
          },
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: 'white',
                textShadow: '0px 1px 2px black'
              }
            },
            point: {
              events: {
                legendItemClick (e) {
                  e.preventDefault()
                  return false
                }
              }
            }
          }
        },
        tooltip: {
          valueSuffix: '%',
          valueDecimals: 1
        },
        series: [{
          name: 'Attendance Share',
          data: [
            ['Metro', 93.1],
            ['Regional', 6.8],
            ['Unknown', 0.1],
          ],
          size: '68%',
          innerSize: '40%',
          borderColor: 'none',
          borderWidth: 1,
          slicedOffset: 30,
          showInLegend: false,
          dataLabels: {
            color: '#000',
            style: {
              textShadow: 'none'
            },
            formatter () {
              if (this.y > 3) {
                return this.y.toFixed(1) + '%'
              }
            },
            distance: -28
          },
          colors: ['#ACDFF4','#F7977A','#82CA9D']
        }, {
          name: 'Revenue Share',
          data: [
            ['Metro', 91.3],
            ['Regional', 8.7],
            ['Unknown', 0.1],
          ],
          size: '100%',
          innerSize: '70%',
          borderColor: 'none',
          borderWidth: 1,
          showInLegend: false,
          dataLabels: {
            color: '#000',
            style: {
              textShadow: 'none'
            },
            formatter () {
              if (this.y > 3) {
                return this.y.toFixed(1) + '%'
              }
            },
            distance: -28
          },
          colors: ['#ACDFF4','#F7977A','#82CA9D']
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 400
            },
            chartOptions: {
              series: [{
              }, {
                id: 'versions',
                dataLabels: {
                  enabled: false
                }
              }]
            }
          }]
        }
      },
      catShares: [
        {
          year: 2025,
          revenue: [
            ['Ballet and Dance', 1.6],
            ['Children\'s/Family', 1.8],
            ['Classical Music', 3.2],
            ['Comedy', 5.1],
            ['Circus and Physical Theatre', 1.5],
            ['Festivals (Multi-Category)', 0.8],
            ['Musical Theatre', 15.6],
            ['Contemporary Music', 54.9],
            ['Opera', 0.6],
            ['Festivals (Contemporary Music)', 11.6],
            ['Special Events', 0.2],
            ['Theatre', 3.2],
          ],
          attendance: [
            ['Ballet and Dance', 1.8],
            ['Children\'s/Family', 4.5],
            ['Classical Music', 5.0],
            ['Comedy', 12.4],
            ['Circus and Physical Theatre', 2.0],
            ['Festivals (Multi-Category)', 2.1],
            ['Musical Theatre', 14.4],
            ['Contemporary Music', 46.5],
            ['Opera', 0.6],
            ['Festivals (Contemporary Music)', 6.0],
            ['Special Events', 0.5],
            ['Theatre', 4.2],
          ]
        }
      ]
    }
  },
  computed: {
    activeCatShare () {
      const self = this

      for (let i = 0; i < self.catShares.length; i++) {
        const catShare = self.catShares[i]
        if (catShare.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick (e) {
                      e.preventDefault()
                      return false
                    }
                  }
                }
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Attendance Share',
              data: catShare.attendance,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: false,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none'
                },
                formatter () {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              },
              colors: ['#BC8DBF', '#70CB92', '#6ECFF6', '#7EA7D8', '#82CA9D', '#8882BE', '#ACDFF4', '#F7977A']
            },
            {
              name: 'Revenue Share',
              data: catShare.revenue,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none'
                },
                formatter () {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              },
              colors: ['#BC8DBF', '#70CB92', '#6ECFF6', '#7EA7D8', '#82CA9D', '#8882BE', '#ACDFF4', '#F7977A']
            }],
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 400
                },
                chartOptions: {
                  series: [{
                  }, {
                    id: 'versions',
                    dataLabels: {
                      enabled: false
                    }
                  }]
                }
              }]
            }
          }
        }
      }

      return false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped="scoped">
.chart-wrapper {
  position: relative;
  .nb {
    // position: absolute;
    // bottom: 0;
    // right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
